export default __webpack_public_path__ + "static/media/charm_tick.e0bb5096.svg";